export abstract class BaseModel {
    public id: any;
    public totalPages: number;
    public totalElements: number;

    public constructor() { }
}
